<template>
  <div>
    <my-header></my-header>

    <div class="content-container-level-1">
      <table class="m3-props-table mb-2">
        <tr>
          <td>
            Последовательность
          </td>
          <td>
            <router-link :to="{name: 'sequence_levels', params: {sequence_id: sequenceProtoId}, query: sequenceQuery}">
              {{sequenceProtoId | getProtoAlias}}
            </router-link>
          </td>
        </tr>
        <tr>
          <td>Номер уровня</td>
          <td>{{levelNumber}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { LevelId } from '../../model/m3level.js';
import { convertOptionalValueToQueryParam } from '../../util.js';

import MyHeader from '../Header.vue';

export default {
  name: 'Level',

  components: {
    MyHeader,
  },

  props: {
    levelId: {
      type: LevelId,
      required: true,
    },

    audienceId: {
      type: Number,
      default: null,
    },
  },

  computed: {
    sequenceProtoId() {
      return this.levelId.sequenceProtoId;
    },

    levelNumber() {
      return this.levelId.number;
    },

    sequenceQuery() {
      return {
        audience: convertOptionalValueToQueryParam(this.audienceId),
      };
    },
  },
}
</script>

<style scoped>
.m3-props-table td:first-child {
  padding-right: .5rem;
}
</style>
